import axios from "../api";

const BASE_URL = "/labeling-evaluation-report";

export const getEvaluationReportConfigApi = () =>
  axios.get(`${BASE_URL}/config`);

export const createEvaluationReportExportApi = (body) =>
  axios.post(`${BASE_URL}/export`, body);

export const getEvaluationReportExportsApi = (params) =>
  axios.get(`${BASE_URL}/exports`, { params });

export const reExportEvaluationReportApi = (exportId) =>
  axios.post(`${BASE_URL}/exports/${exportId}/re-export`);
